//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import AppContainer from "../../layout/AppContainer.vue";
import ErrorDisplay from "../../common/ErrorDisplay.vue";
import InlineSpinner from "../../common/InlineSpinner.vue";

export default {
  data() {
    return {
      member: {},
      error: null,
      success: null,
      show_form: true,
      show_check: false,
      updating: false,
    };
  },
  validations: {
    member: {
      currentPassword: {
        required,
        minLength: minLength(8),
      },
      newPassword: {
        required,
        minLength: minLength(8),
        capital: (value) => /[A-Z]+/.test(value),
        lower: (value) => /[a-z]+/.test(value),
        number: (value) => /[0-9]+/.test(value),
        symbol: (value) => /[#@!$%^&*()_|~`{}\[\]:";'<>?,.\/]+/.test(value),
      },
      reenterPassword: {
        required,
        sameAsNewPassword: sameAs("newPassword"),
      },
    },
  },
  methods: {
    async changePassword() {
      try {
        this.updating = true;
        this.error = false;
        const result = await this.$store.dispatch("changePassword", {
          oldPassword: this.member.currentPassword,
          newPassword: this.member.newPassword,
        });

        this.member.currentPassword = "";
        this.member.newPassword = "";
        this.member.reenterPassword = "";
        this.$v.$reset();
        this.success = result;
        this.show_check = true;
        this.show_form = false;
        setTimeout(() => {
          this.show_check = false;
        }, 4000);
      } catch (error) {
        this.error = true;
        this.member.currentPassword = "";
        this.show_form = false;
        setTimeout(() => {
          this.error = null;
        }, 4000);
      } finally {
        this.updating = false;
        this.$nextTick(() => {
          this.show_form = true;
        });
      }
    },
    get_member_id() {
      return this.user.memberId;
    },
    cancel_save() {
      this.member.currentPassword = "";
      this.member.newPassword = "";
      this.member.reenterPassword = "";
      this.error = null;
      this.updating = null;
      this.$v.$reset();
      this.show_form = false;
      this.$nextTick(() => {
        this.show_form = true;
      });
    },
  },
  computed: {
    ...mapGetters(["user"]),
    new_password_state() {
      if (this.$v.$dirty) {
        return (
          this.$v.member.newPassword.minLength &&
          this.$v.member.newPassword.required &&
          this.$v.member.newPassword.capital &&
          this.$v.member.newPassword.lower &&
          this.$v.member.newPassword.symbol
        );
      }
      return null;
    },
    reenter_state() {
      if (this.$v.$dirty) {
        return this.$v.member.reenterPassword.sameAsNewPassword;
      }
      return null;
    },
  },
  components: {
    AppContainer,
    ErrorDisplay,
    InlineSpinner,
  },
};
